<template>
    <div>
        <EDSSign v-if="document" :guid="guid" :is_engineer="true" :document="document" />
        <StylusSign v-if="document" :guid="guid" :is_engineer="true" />
        <QRCodeSign v-if="document" :guid="guid" :is_engineer="true" :document="document" />
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import EDSSign from '@/components/sign_document/EDSSign.vue';
import StylusSign from '@/components/sign_document/StylusSign.vue';
import QRCodeSign from '@/components/sign_document/QRCodeSign.vue';
export default {
    components: {
        EDSSign,
        StylusSign,
        QRCodeSign
    },
    data: () => ({
        guid: '5B6589ED-4DC5-40F1-A4A4-C977E7DC1DB5'
    }),
    computed: {
        ...mapState('documents', ['DocTypeList', 'document'])
    },
    methods: {
        ...mapActions('documents', ['getAttachment'])
    },
    async mounted() {
        await this.getAttachment({ iAttachmentLinkRid: 16530582 });
    }
};
</script>
